<div class="guide-section">
  <div class="row">
    <div class="guide-section__title">
      Blackout dates
      @if (showExpansionGuide === 'customDates' || exp4.expanded == true) {
        <div class="guide-section__subtext">Show this option only if these rules match</div>
      }
    </div>
    <div class="content__custom-blackout-dates">
      <mat-accordion>
        <mat-expansion-panel
          (opened)="onOpenExpansion('customDates')"
          (closed)="onCloseExpansion()"
          [expanded]="isExpandedNeeded('customDates')"
          #exp4="matExpansionPanel">
          <mat-expansion-panel-header>
            <mat-panel-description>
              <div
                class="content__custom-blackout-dates__title"
                [ngClass]="exp4.expanded == true ? 'margin-title-exp' : ''">
                Blackout dates
              </div>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <form [formGroup]="formGroup">
            <div class="row">
              <div class="content__custom-blackout-dates__select-position">
                <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                <app-custom-datepicker
                  [startDate]="startDate"
                  [endDate]="endDate"
                  (changeDateRange)="handleDateRangeChange($event)"
                  [withActions]="true"
                  [showPlaceholder]="true"
                  variant="form"></app-custom-datepicker>
              </div>

              <div class="content__custom-blackout-dates__input">
                <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                <input
                  class="pdq-mat-input"
                  type="text"
                  style="width: 240px"
                  placeholder="Optional note"
                  formControlName="blackoutDaysNote"
                  [(ngModel)]="blackoutDaysNote" />
              </div>
              <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate tooltip to Storybook  -->
              <pdq-button
                variant="dark"
                (onClick)="addBlackoutDate()"
                [matTooltip]="'Add blackout dates'"
                matTooltipClass="pdq-mat-tooltip">
                Apply
              </pdq-button>
            </div>
            @if (showCustomBlackoutDateErrorMsg) {
              <div style="font-size: 13px; color: red">
                {{ showCustomBlackoutDateErrorMsg }}
              </div>
            }
            <div class="custom-divier"></div>
            @for (blackoutDays of formGroup.get('customBlackoutDates')['value']; track blackoutDays; let i = $index) {
              <div formArrayName="customBlackoutDates">
                <div class="row spaceTop">
                  <div class="content__custom-blackout-dates__box">
                    {{ blackoutDays['startDate'] | date }} -
                    {{ blackoutDays['endDate'] | date }}
                  </div>
                  <div class="content__custom-blackout-dates__box">
                    {{ blackoutDays['note'] }}
                  </div>
                  <button class="content__custom-blackout-dates__add-icon" (click)="removeBlackoutDate(i)">
                    <img
                      alt=""
                      style="margin-top: 2px"
                      src="assets/checkout-icons/x-icon.svg"
                      [matTooltip]="'Remove'"
                      matTooltipClass="pdq-mat-tooltip" />
                  </button>
                </div>
              </div>
            }
          </form>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
